import type { IntegrationBusinessUnit } from 'api';

export const BusinessUnitOption = ({
  name,
  default: isDefault
}: IntegrationBusinessUnit) => (
  <div className="flex items-center justify-between gap-2">
    <span className="truncate">{name}</span>
    {isDefault && <span className="shrink-0 text-gray-400">Default</span>}
  </div>
);
